<template>
  <v-container class="pa-0 align-start">
    <v-row class="" dense>
      <v-col cols="12">
        <navTabs />
      </v-col>
    </v-row>
    <v-container class="fill-height align-center">
      <sys-references-view />
    </v-container>
  </v-container>
</template>

<script>
import navTabs from '@/components/common/ui/navTabs.vue'
import SysReferencesView from '@/views/references/subpages/refList'
export default {
  components: {
    SysReferencesView,
    navTabs
  },
  data () {
    return {
    }
  },
  methods: {

  }

}
</script>
